import React from 'react';
import AppPaths from '../../AppPaths';
import { Redirect, useLocation } from 'react-router-dom';
import useHardwareFirstShop from '../../hooks/useHardwareFirstShop';

/**
 * The shop root. `hardware-first-checkout-2` decides where it lands: the pick-your-fi shop for
 * visitors the arm covers, the classic listing for everyone else. Redirecting straight to the
 * destination keeps the non-US hop off `/shop`, which would bounce them here anyway.
 */
export default function Home() {
  const location = useLocation();
  const shopEnabled = useHardwareFirstShop();

  return (
    <Redirect to={{ pathname: shopEnabled ? AppPaths.Shop : AppPaths.ProductListingPage, search: location.search }} />
  );
}
